import { createContext } from 'react'

import type { Dispatch, SetStateAction } from 'react'

export const LoadingContext = createContext<
  [{ isLoading: boolean }, Dispatch<SetStateAction<{ isLoading: boolean }>>]
>([{ isLoading: false }, () => {}])
